import { CrossIcon } from "@aureskonnect/react-ui";
import { CustomCardHeader } from "@components/Common/CustomCardStyled";
import React from "react";

interface Props {
    title: string;
    onClose: () => void;
}

const SalesSupportHeader: React.FC<Props> = ({ title, onClose }) => (
    <CustomCardHeader
        className="d-flex align-items-center justify-content-between"
        style={{ maxHeight: "76px" }}
    >
        <h5 className="pt-3 sdv_txt_FRtitleFormSalesSupport">{title}</h5>
        <CrossIcon
            className="icon-close-notification__clz sdv_icn_FRcloseForm"
            height={13}
            width={13}
            onClick={onClose}
        />
    </CustomCardHeader>
);

export default SalesSupportHeader;
